<template>
  <div class="py-20 bg-charcoal relative overflow-hidden">
    <div class="lg:mb-4 container flex items-center justify-between mb-8">
      <div v-if="tagLine" class="text-br-green fluid-xs leading-tightest lg:pl-32" v-html="tagLine"></div>
      <ArrowBtnNav
        class="lg:hidden"
        :inverted="true"
        :left-arrow-disabled="isFirst"
        :right-arrow-disabled="isLast"
        @onLeftClick="prevSlide"
        @onRightClick="nextSlide"
      />
    </div>
    <div class="relative">
      <div class="lg:block hidden mb-8 container">
        <ArrowBtnNav
          class="lg:absolute lg:top-0 lg:w-auto block z-10"
          :inverted="true"
          :left-arrow-disabled="isFirst"
          :right-arrow-disabled="isLast"
          @onLeftClick="prevSlide"
          @onRightClick="nextSlide"
        />
      </div>
      <CardSlider
        ref="valueRotationSlider"
        :breakpoints="breakpoints"
        :show-arrows="false"
        :display-overflow="true"
        @change="setActiveSlide"
      >
        <div
          v-for="(slide, index) in valueSlides"
          :key="index"
          class="text-br-green-light lg:pl-32 relative pr-12 transition-opacity duration-700"
          :class="{ 'opacity-30': index !== activeSlideIndex }"
        >
          <h2 class="fluid-4xl leading-none" v-html="slide.claim"></h2>
        </div>
      </CardSlider>
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag';
import ArrowBtnNav from '@/components/common/ArrowBtnNav';
import CardSlider from '@/components/common/CardSlider';

export default defineNuxtComponent({
  components: { CardSlider, ArrowBtnNav },
  props: {
    tagLine: {
      type: String,
      default: null,
    },
    valueSlides: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      activeSlideIndex: 0,
      isFirst: false,
      isLast: false,
      breakpoints: [
        {
          minWindowWidth: 0,
          slidesToShow: 1,
          slidesToScroll: 1,
        },
        {
          minWindowWidth: 768,
          slidesToShow: 1.2,
          slidesToScroll: 1,
        },
      ],
    };
  },
  methods: {
    setActiveSlide(state) {
      if (typeof state !== 'object') return;
      if ('currentSlide' in state) {
        this.activeSlideIndex = state.currentSlide;
      }
      if ('isFirst' in state) {
        this.isFirst = state.isFirst;
      }
      if ('isLast' in state) {
        this.isLast = state.isLast;
      }
    },
    prevSlide() {
      this.$refs.valueRotationSlider.prev();
    },
    nextSlide() {
      this.$refs.valueRotationSlider.next();
    },
  },
});
</script>
